import { mTheme } from './themes'

export const displayOnSmallOnly: Style = {
  display: 'none',
  [mTheme.breakpoint.belowMedium]: {
    display: 'block',
  },
}
